import { Quota } from '@xver/@types/quota';
import httpClient from '@xver/libs/axios';

const ENDPOINTS = {
    GET: '/v1/quotas',
};

export function getQuotas(): Promise<Quota[]> {
    return httpClient.get<void, Quota[]>(ENDPOINTS.GET);
}
